<script setup lang="ts">
  import { toRef } from 'vue'

  interface ISpinnerProps {
    message?: string
    isLoading: boolean
  }

  const props = defineProps<ISpinnerProps>()

  const isLoading = toRef(props.isLoading)
</script>

<template>
  <div v-if="isLoading" class="loading-state">
    <div class="spinner"></div>
    <p>{{ props.message ?? 'Loading...' }}</p>
  </div>
</template>

<style scoped>
  .loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 12px;
  }

  .spinner {
    width: 32px;
    height: 32px;
    border: 3px solid #e5e5e5;
    border-top: 3px solid var(--primary);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
